import React from "react";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import { TextField } from "@material-ui/core";
import _ from "lodash";
import XAPPButton from "app/Core/Components/Button/XAPPButton";

class Memed extends XAPPComponent {

   canBeSubmitted = () => {
      const { data } = this.props;
      if (data?.setup && data.setup.token && !_.isNull(data.setup.token)) {
         return false;
      }
      return (
         data.idpessoaformulario && !_.isNull(data.idpessoaformulario) && data.idpessoaformulario !== "" &&
         data.registroconselho && !_.isNull(data.registroconselho) && data.registroconselho !== "" &&
         data.registroconselhouf && !_.isNull(data.registroconselhouf) && data.registroconselhouf !== "" &&
         data.documentoprimario && !_.isNull(data.documentoprimario) && data.documentoprimario !== ""
      );
   };

   render() {
      const { data, xappRouteParams, integracao } = this.props;

      return (
         <React.Fragment>
            <div className="flex sm:flex-no-wrap flex-wrap">
               <TextField
                  className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                  label={"CPF"}
                  id="documentoprimario"
                  name="documentoprimario"
                  disabled={true}
                  value={data.documentoprimario}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
               />
               <TextField
                  className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                  label={"CRM"}
                  id="registroconselho"
                  name="registroconselho"
                  disabled={true}
                  value={data.registroconselho}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
               />
               <TextField
                  className="mb-12 lg:w-1/3 xs:w-full"
                  label={"UF"}
                  id="registroconselhouf"
                  name="registroconselhouf"
                  disabled={true}
                  value={data.registroconselhouf}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
               />
            </div>
            <div className="flex sm:flex-no-wrap flex-wrap">
               <TextField
                  className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                  label={"Contato"}
                  id="fone"
                  name="fone"
                  disabled={true}
                  value={data.fone}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
               />
               <TextField
                  className="mb-12 lg:w-2/3 xs:w-full"
                  label={"Email"}
                  id="email"
                  name="email"
                  disabled={true}
                  value={data.email}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
               />
            </div>
            <div className="flex w-full items-center justify-center mb-12">
               <XAPPButton
                  type="Button"
                  className=" text-white mr-8"
                  variant="contained"
                  disabled={!this.canBeSubmitted()}
                  color="primary"
                  onClick={() => integracao("registrar-medico", data, xappRouteParams, "MEDICO_MEMED")}
                  iconProps="mr-8"
                  icon={"refresh"}
                  label={"Gerar token"}
               />
            </div>
         </React.Fragment>
      );
   }
}

export default Memed;
